<template>
  <div class="dynamic-header" v-if="content">
    <BeforeAfterSlider class="header-bg"
      v-if="useSlider"
      :before="content.bgImage"
      :after="content.bgImage2" />

    <div v-if="!hasVideo && !useSlider" class="header-bg" :style="'background-image: url(' + content.bgImage + ')'"></div>
    <div v-if="hasVideo && !useSlider" class="header-bg">
      <video autoplay muted loop>
        <source :src="content.bgWebm" type="video/webm">
        <source :src="content.bgMp4" type="video/mp4">
        <source :src="content.bgOgg" type="video/ogg">
        <!-- Fallback -->
        <img :src="content.bgImage">
      </video>
    </div>
    <div class="header-content">
      <div>
        <h1>{{ content.heading }}</h1>
        <p class="caption">{{ content.subHeading }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import BeforeAfterSlider from "./BeforeAfterSlider";

export default {
  name: "DynamicHeader",
  components: {
    BeforeAfterSlider,
  },

  props: {
    content: {
      type: Object,
    },
  },
  computed: {
    hasVideo() {
      return this.content.bgWebm || this.content.bgMp4 || this.content.bgOgg;
    },
    useSlider() {
      return !!this.content.bgImage && this.content.bgImage2;
    }
  },
};
</script>

<style scoped>
.dynamic-header {
  width: 100%;  
}

.header-bg {
  z-index: 1;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-position: 50% 15%;
  background-size: cover;
  opacity: .6;
}

.header-bg video,
.header-bg img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.header-content {
  z-index: 2;
  position: relative;
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 25px 80px;
  pointer-events: none;
}

.header-content > div {
  max-width: 50%;
}

.header-content h1 {
  margin-bottom: 20px;
  font-size: 75px;
}

.caption {
  font-family: Georgia,'Times New Roman',Times,serif;
  font-size: 22px;
  font-weight: 300;
  letter-spacing: 1px;
}

@media only screen and (max-width: 40em) {
  .header-bg {
    background-position: 41%;
  }

  .header-content {
    padding-top: 320px;
    padding-bottom: 0;
    text-align: center;
  }

  .header-content > div {
    max-width: 100%;
  }

  .header-content h1 {
    font-size: 46px;
  }

  .caption {
    font-size: 18px;
  }
}

@media only screen and (max-width: 374px) {
  .header-content {
    padding-top: 283px;
  }

  .header-content h1 {
    font-size: 38px;
  }
}

</style>


// WEBPACK FOOTER //
// Header.vue?44beecd2